import {BaseCollectionModel, SearchModel, YascEntityApiAdapterV3} from '@yasc/yasc-material-components';
import {Observable} from 'rxjs';
import {
    CompanyFiscalYearCreateReq,
    CompanyFiscalYearRes,
    CompanyFiscalYearUpdateReq,
} from '../../../../contracts/v0/administration/fiscal-year.contracts';
import {RestApiService} from '../../../rest-api.service';
import {ApiV0Administration} from '../api.v0.administration';

export class ApiV0AdminFiscalYears implements YascEntityApiAdapterV3<
    CompanyFiscalYearRes,
    CompanyFiscalYearRes,
    CompanyFiscalYearCreateReq,
    CompanyFiscalYearUpdateReq,
    number
> {
    readonly idKey = 'id' as const;
    readonly modelTypes = {
        row: CompanyFiscalYearRes,
        detail: CompanyFiscalYearRes,
        create: CompanyFiscalYearCreateReq,
        patch: CompanyFiscalYearUpdateReq,
    };

    readonly segment: string;

    constructor(v0: ApiV0Administration, private readonly rest: RestApiService) {
        this.segment = `${v0.segment}/FiscalYears`;
    }

    search(model: SearchModel = new SearchModel({})): Observable<BaseCollectionModel<CompanyFiscalYearRes>> {
        return this.rest.post<SearchModel, BaseCollectionModel<CompanyFiscalYearRes>>(
            `${this.segment}/search`,
            CompanyFiscalYearRes,
            model,
        );
    }

    detail(id: number): Observable<CompanyFiscalYearRes> {
        return this.rest.get<CompanyFiscalYearRes>(`${this.segment}/${id}`, CompanyFiscalYearRes);
    }

    create(req: CompanyFiscalYearCreateReq): Observable<CompanyFiscalYearRes> {
        return this.rest.post<CompanyFiscalYearCreateReq, CompanyFiscalYearRes>(
            this.segment,
            CompanyFiscalYearRes,
            req,
        );
    }

    patch(id: number, req: CompanyFiscalYearUpdateReq): Observable<CompanyFiscalYearRes> {
        return this.rest.patch<CompanyFiscalYearUpdateReq, CompanyFiscalYearRes>(
            `${this.segment}/${id}`,
            CompanyFiscalYearRes,
            req,
        );
    }
}
